<input class="input" type="text" [(ngModel)]="DisplayValue"  (focus)="InputEntered()" (blur)="InputBlurred()" [disabled]="Disabled">
